import {QuestionnaireEntryPage} from "../QuestionnaireEntryPage";
import {QuestionnaireSimplePage} from "../QuestionnaireSimplePage";

// Enum to define the available pages in the registration flow
export enum PagesEnum {
  First,
  Simple
}

// Singleton class to control which page is currently shown
export class NewAccountPageTrigger {
  // Static singleton instance to be used across components
  static instance: NewAccountPageTrigger = new NewAccountPageTrigger()

  // Optional function to externally update the currently displayed page
  setNewAccountShowPage: ((page: PagesEnum) => void) | undefined = undefined;

  // Method to return the correct page component based on the enum value
  getShowPage = (pageEnum: PagesEnum): JSX.Element => {
    // If the setter hasn't been defined yet, return an empty div
    if(this.setNewAccountShowPage === undefined) return <div></div>;

    // Choose which page to render based on the enum value
    switch (pageEnum){
      case PagesEnum.First:
        return <QuestionnaireEntryPage />
      case PagesEnum.Simple:
        return <QuestionnaireSimplePage />
      default:
        return <div></div>;  // Fallback if enum doesn't match any case
    }
  }
}
